import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { removeSiteUsersFromGroup } from '../../groups/actions/GroupMenuActions';
import { IGroupInfo } from '../../groups/models/IGroupInfo';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserRemoveFromGroupAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemoveFromGroup,
  translateName: Messages.remove_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    const group = state.spaceInfo.item as IGroupInfo;
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && state.spaceInfo.spaceType === 'group'
      && !group.isAllUsersGroup;
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => removeSiteUsersFromGroup(targetItems)
};
